import React, { useState } from 'react';
import { Save } from 'lucide-react';
import { apiCall, useAdminData } from './_helpers';

const NewsletterCopyManager = ({ onMessage }) => {
  const [data, setData, refetch] = useAdminData('newsletter-copy', {});
  const [saving, setSaving] = useState(false);

  const fields = [
    ['section_heading', 'Section Heading (homepage)'],
    ['section_body', 'Section Body'],
    ['section_button_label', 'Section Button Label'],
    ['section_privacy_note', 'Section Privacy Note'],
    ['modal_heading', 'Modal Heading'],
    ['modal_body', 'Modal Body'],
    ['modal_button_label', 'Modal Button Label'],
    ['modal_privacy_note', 'Modal Privacy Note'],
    ['success_message', 'Success Toast Message'],
  ];

  const save = async () => {
    setSaving(true);
    try { await apiCall('PUT', 'newsletter-copy', data); onMessage('success', 'Saved'); refetch(); }
    catch (e) { onMessage('error', e.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-md">
      <h2 className="text-2xl font-bold mb-6">Newsletter Copy</h2>
      <div className="space-y-4">
        {fields.map(([k, label]) => (
          <div key={k}>
            <label className="block text-sm font-medium mb-1">{label}</label>
            <input type="text" value={data[k] || ''} onChange={(e) => setData({ ...data, [k]: e.target.value })} className="w-full border rounded-lg px-4 py-2" />
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} className="mt-6 bg-[#C9A86C] text-white px-6 py-2 rounded-lg flex items-center gap-2 hover:bg-[#B8956A] disabled:opacity-50">
        <Save size={18} /> {saving ? 'Saving…' : 'Save Changes'}
      </button>
    </div>
  );
};

export default NewsletterCopyManager;
